// src/pages/dashboard/TukTukBookings.tsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import Sidebar from "../../sidebar/sidebar";
import axios from "axios";
import BookingTable from "./components/BookingTable";

interface TukTukPurchaseDTO {
  compraId: number;
  status: string;
  pacoteId: number;
  pacoteNome: string;
  motoristaId: number;
  motoristaNome: string;
  dataReserva: string;
  horaReserva: string;
  adultos: number;
  criancas: number;
  quantidadePessoas: number;
  precoTotal: number;
}

const TukTukBookings: React.FC = () => {
  const [data, setData] = useState<TukTukPurchaseDTO[]>([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { label: "Dashboard", link: "/agent-dashboard" },
    { label: "Tuk Tuk Bookings", link: "" },
  ];

  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get<TukTukPurchaseDTO[]>(
          `${process.env.REACT_APP_API_URL}/empresas/dashboard/tuktuk-purchases`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          }
        );
        setData(res.data);
      } catch (error) {
        console.error("Erro ao buscar bookings de Tuk Tuk:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();
  }, []);

  if (loading) return <p>Carregando bookings de Tuk Tuk...</p>;

  return (
    <div>
      <Breadcrumb
        title="Tuk Tuk Bookings"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-04"
      />

      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>
            {/* /Sidebar */}

            {/* Tuk Tuk Bookings */}
            <div className="col-xl-9 col-lg-8 theiaStickySidebar">
              {/* Booking Header */}
              <div className="card booking-header border-0 mb-3">
                <div className="card-body header-content d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <h6 className="mb-1">Tuk Tuk Bookings</h6>
                    <p className="fs-14 text-gray-6 fw-normal">
                      No of Booking : {data.length}
                    </p>
                  </div>
                  <div className="d-flex align-items-center flex-wrap">
                    {/* Aqui você pode adicionar filtros de data/status */}
                  </div>
                </div>
              </div>
              {/* /Booking Header */}

              {/* Booking List */}
              <div className="card hotel-list">
                <div className="card-body p-3">
                  <h6 className="mb-3">Booking List</h6>
                  <BookingTable
                    data={data}
                    rowKey="compraId"
                    searchFields={["pacoteNome", "motoristaNome"]}
                    statusField="status"
                    columns={[
                      {
                        title: "Pacote",
                        dataIndex: "pacoteNome",
                        render: (text, record) => (
                          <Link to={`/flight-details/${record.pacoteId}`}>
                            {text}
                          </Link>
                        ),
                      },
                      { title: "Motorista", dataIndex: "motoristaNome" },
                      { title: "Data Reserva", dataIndex: "dataReserva" },
                      { title: "Hora Reserva", dataIndex: "horaReserva" },
                      { title: "Adultos", dataIndex: "adultos" },
                      { title: "Crianças", dataIndex: "criancas" },
                      { title: "Total Pessoas", dataIndex: "quantidadePessoas" },
                      {
                        title: "Preço Total",
                        dataIndex: "precoTotal",
                        render: (value: number) => `€ ${value.toFixed(2)}`,
                      },
                      { title: "Status", dataIndex: "status" },
                    ]}
                  />
                </div>
              </div>
              {/* /Booking List */}
            </div>
            {/* /Tuk Tuk Bookings */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TukTukBookings;
